"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HourlyBreakdown = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var HourlyBreakdownTypes_1 = require("./HourlyBreakdownTypes");
var luxon_1 = require("luxon");
var Col_1 = require("@amzn/atoz-web/Col");
var Row_1 = require("@amzn/atoz-web/Row");
var Text_1 = require("@amzn/atoz-web/Text");
var Card_1 = require("@amzn/atoz-web/Card");
var Icons_1 = require("@amzn/atoz-web/Icons");
var Theme_1 = require("@amzn/atoz-web/Theme");
var HourlyBreakdown = function (_a) {
    var hourlyBreakdownList = _a.hourlyBreakdownList;
    var t = (0, react_i18next_1.useTranslation)().t;
    var hourlyBreakdownListElements = hourlyBreakdownList
        ? Object.entries(hourlyBreakdownList).map(function (hourlyBreakdownItem) {
            var duration = luxon_1.Duration.fromObject({
                minute: hourlyBreakdownItem[1]
            })
                .shiftTo('hours', 'minutes')
                .toObject();
            var durationStr = "".concat(duration.hours, "h ").concat(duration.minutes, "m");
            if (Object.values(HourlyBreakdownTypes_1.UptPaycode).includes(hourlyBreakdownItem[0])) {
                return (react_1.default.createElement(Row_1.Row, { key: hourlyBreakdownItem[0], alignItems: "center" },
                    react_1.default.createElement(Icons_1.IconAlertCircleFill, { color: "red60-alpha90", size: Icons_1.IconSize.Small, margin: { right: 'S200' } }),
                    react_1.default.createElement(Text_1.Text, null, "UPT: ".concat(durationStr))));
            }
            else {
                return (react_1.default.createElement(Row_1.Row, { key: hourlyBreakdownItem[0], alignItems: "center" },
                    react_1.default.createElement(Text_1.Text, null, "".concat(hourlyBreakdownItem[0], ": ").concat(durationStr))));
            }
        })
        : [];
    return (react_1.default.createElement(StyledCard, { dataTestId: "HourlyBreakdownFromInternal" },
        react_1.default.createElement(Col_1.Col, { gridGap: "S200" },
            react_1.default.createElement(Row_1.Row, null,
                react_1.default.createElement(Text_1.Text, { fontWeight: "bold" }, t('time_and_attendance_HourlyBreakdown_title'))),
            hourlyBreakdownListElements.length ? (hourlyBreakdownListElements) : (react_1.default.createElement(Row_1.Row, { "data-testid": "noHourlyBreakdown", alignItems: "center" }, t('time_and_attendance_HourlyBreakdown_empty'))))));
};
exports.HourlyBreakdown = HourlyBreakdown;
var StyledCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: none;\n"], ["\n    border: none;\n"])));
var templateObject_1;
